import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import WebSidebar from '@/components/organisms/WebSidebar';
import { useDeviceType } from '@/hooks/useDeviceType';
import DashboardHeader from '@/components/organisms/DashboardHeader';
import MobileBottonNavigation from '@/components/molecules/MobileBottonNavigation';

interface AdminDashboardTemplateProps {
  children: React.ReactNode;
  className?: string;
}

const AdminDashboardTemplate: React.FC<AdminDashboardTemplateProps> = ({ children, className = '' }) => {
  const location = useLocation();
  const mainContentRef = useRef<HTMLDivElement>(null);
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const { isMobileView } = useDeviceType();

  // Function to check if current path is a sub-page
  const isSubPage = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    return pathSegments.length > 2; // Returns true if path has more than one segment
  };

  // Reset scroll position when route changes
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  // Show bottom navigation only on mobile AND main pages
  const showBottomNav = isMobileView && !isSubPage();

  return (
    <div className="flex flex-col md:flex-row items-stretch h-[100dvh] bg-primary md:bg-transparent overflow-hidden">
      {/* Admin Sidebar */}
      {!isMobileView && <WebSidebar />}

      {/* Main Content */}
      <div
        className={`overflow-y-hidden overflow-x-hidden relative bg-[#FBFBFF] w-full flex flex-1 md:flex-auto md:flex md:flex-col md:rounded-none shadow-[0px_20px_20px_0px_#00000033] md:shadow-none  ${!showBottomNav ? '' : 'rounded-b-[36px]'}`}
      >
        {/* Header */}
        {!isMobileView && <DashboardHeader />}

        {/* Main Content Area */}
        <main ref={mainContentRef} className={`flex-1 p-4 md:p-6 overflow-y-auto ${className}`}>
          {children}
        </main>
      </div>

      {/* BOTTOM BAR NAVIGATION - MOBILE */}
      {showBottomNav && (
        <div className="h-[94px] px-6 flex items-center md:h-[48px] md:fixed md:bottom-0 md:left-0 md:right-0 bg-primary">
          <MobileBottonNavigation />
        </div>
      )}
    </div>
  );
};

export default AdminDashboardTemplate;
